export const VALUE_FORMATS = ["NUMERIC", "ALPHANUMERIC"] as const;

export type FarmerIdentificationValueFormat = (typeof VALUE_FORMATS)[number];

export const VALUE_FORMAT_LABEL_KEYS: Record<FarmerIdentificationValueFormat, string> = {
  ALPHANUMERIC: "farmerIdentification.form.formatOptions.alphanumeric",
  NUMERIC: "farmerIdentification.form.formatOptions.numeric",
};

export const toValueFormat = (value: unknown): FarmerIdentificationValueFormat | undefined =>
  VALUE_FORMATS.find(
    format =>
      format ===
      String(value ?? "")
        .trim()
        .toUpperCase()
  );
